import React, { useEffect, useState } from 'react';
import chatEventEmitter from './chatEventEmitter';
import './index.less';

const SessionClosed = ({ supportGuideLink, t = (term) => term }) => {
    const i18n = typeof window.global_i18n === 'function' ? window.global_i18n : t;

    const [userResponse, setUserResponse] = useState(null);
    const [showContactMessage, setShowContactMessage] = useState(false);

    useEffect(() => {
        if (!userResponse) return;
        if (typeof usageTrackEvent === 'function') {
            usageTrackEvent('ai support agent answer rated', {
                answered_question: userResponse === 'yes',
            });
        }
    }, [userResponse]);

    return (
        <div className="session_closed_wrap">
            <div>
                <div className="session_title">{i18n('Did this answer your question?')}</div>
                <div className="btn_wrap">
                        <button
                            onClick={() => setUserResponse('yes')}
                            className={userResponse === 'yes' ? 'active' : ''}
                        >
                            <span className='icon-svg-thumbs-up'></span>{i18n('Yes')}
                        </button>
                        <button
                            onClick={() => {
                                setUserResponse('no');
                                setShowContactMessage(false);
                            }}
                            className={userResponse === 'no' ? 'active' : ''}
                        >
                            <span className='icon-svg-thumbs-down'></span>{i18n('No')}
                        </button>
                </div>
                {userResponse === 'no' && (
                    <div className="contact_support_wrap">
                        <button
                            className='contac_btn'
                            onClick={() => {
                                if (window.Intercom) {
                                    window.Intercom('show');
                                }
                                chatEventEmitter.emit('closeChat');
                            }}
                            disabled={showContactMessage}
                        >
                            <span className='icon-svg-users-01'></span>{i18n('Contact support')}
                        </button>
                        <button onClick={() => window.open(supportGuideLink, '_blank')} className='guide_btn'><span className='icon-svg-link-external-02'></span>{i18n('Open guides')}</button>
                    </div>
                )}
            </div>

            {userResponse === 'yes' && (
                <div className="session_closed">
                    <span>{i18n('Session closed')}</span>
                </div>
            )}
        </div>
    );
};

export default SessionClosed;
